var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "middle", staticClass: "main_center" }, [
    _c("div", { staticClass: "track-content" }, [
      _c(
        "div",
        { staticClass: "track-top" },
        [
          _c(
            "el-select",
            {
              attrs: {
                "popper-append-to-body": false,
                placeholder: "请选择",
                "value-key": "value",
              },
              on: { change: _vm.selectChange },
              model: {
                value: _vm.filedItem,
                callback: function ($$v) {
                  _vm.filedItem = $$v
                },
                expression: "filedItem",
              },
            },
            _vm._l(_vm.options, function (group) {
              return _c(
                "el-option-group",
                { key: group.label, attrs: { label: group.label } },
                _vm._l(group.children, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item },
                  })
                }),
                1
              )
            }),
            1
          ),
          _c(
            "div",
            { staticClass: "top-date" },
            [
              _vm._v(" " + _vm._s(_vm._f("updatetime")(_vm.nowtime)) + " "),
              _c("el-button", {
                staticClass: "el-icon-rank full",
                attrs: { type: "text" },
                on: { click: _vm.screen },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "track-middle" },
        [
          _vm.videoList.length > 0
            ? _c(
                "el-row",
                { attrs: { gutter: 6 } },
                [
                  _vm.videoList.length > 0
                    ? _c(
                        "el-carousel",
                        {
                          staticStyle: { height: "900px" },
                          attrs: {
                            autoplay: false,
                            "indicator-position": "none",
                          },
                        },
                        _vm._l(
                          Math.ceil(_vm.videoList.length / 6),
                          function (i) {
                            return _c(
                              "el-carousel-item",
                              { key: i, staticStyle: { height: "900px" } },
                              _vm._l(
                                _vm.videoList.slice(
                                  (i - 1) * 6,
                                  _vm.videoList.length >= i * 6
                                    ? i * 6
                                    : _vm.videoList.length
                                ),
                                function (item, index) {
                                  return _c(
                                    "el-col",
                                    {
                                      key: item.id,
                                      staticStyle: { "margin-bottom": "6px" },
                                      attrs: {
                                        span:
                                          _vm.total <= 1
                                            ? 24
                                            : _vm.total <= 4
                                            ? 12
                                            : 8,
                                      },
                                    },
                                    [
                                      _c("guardVideo", {
                                        attrs: {
                                          videoInfo: item,
                                          i: index,
                                          total: _vm.total,
                                          record: true,
                                          height:
                                            _vm.total <= 2 ? "900px" : "450px",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                }
                              ),
                              1
                            )
                          }
                        ),
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _c(
                "el-row",
                { staticStyle: { position: "relative", height: "900px" } },
                [
                  _vm.isIE
                    ? _c("iframe", {
                        staticStyle: {
                          position: "absolute",
                          "z-index": "-1",
                          width: "100%",
                          height: "100%",
                          top: "0",
                          left: "0",
                          right: "0",
                          bottom: "0",
                        },
                        attrs: { allowtransparency: "true", frameborder: "0" },
                      })
                    : _vm._e(),
                  _c("stream-player", {
                    ref: "streamPlayerRefs1",
                    attrs: {
                      width: "850px",
                      height: _vm.vlcHeight,
                      "video-url": _vm.videoUrl,
                      "video-code": "flv",
                    },
                    on: {
                      "update:videoUrl": function ($event) {
                        _vm.videoUrl = $event
                      },
                      "update:video-url": function ($event) {
                        _vm.videoUrl = $event
                      },
                    },
                  }),
                ],
                1
              ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }